import { REASSIGNMENT_PARTNER_PHYSICIAN, REASSIGNMENT_TREATING_PHYSICIAN, REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectReassignment = state => {
    return selectOwnState(state).reassignment
}

export const selectIsReassignmentTreatingPhysician = state => {
    return selectReassignment(state).reassignTo === REASSIGNMENT_TREATING_PHYSICIAN
}

export const selectIsReassignmentPartnerPhysician = state => {
    return selectReassignment(state).reassignTo === REASSIGNMENT_PARTNER_PHYSICIAN
}

export const selectCurrentTreatingPhysicianId = state => {
    return selectReassignment(state).currentTreatingPhysicianId
}

export const selectNewTreatingPhysicianId = state => {
    return selectReassignment(state).newTreatingPhysicianId
}

export const selectPartnerPhysicianId = state => {
    return selectReassignment(state).partnerPhysicianId
}

export const selectConfirmationLegalRequirementsMet = state => {
    return selectReassignment(state).confirmationLegalRequirementsMet
}

export const selectCanProceed = state => {
    const confirmation = selectConfirmationLegalRequirementsMet(state)
    if (!confirmation) {
        return false
    }

    const isReassignmentTreatingPhysician = selectIsReassignmentTreatingPhysician(state)
    const isReassignmentPartnerPhysician = selectIsReassignmentPartnerPhysician(state)


    const currentTreatingPhysicianId = selectCurrentTreatingPhysicianId(state)
    const newTreatingPhysicianId = selectNewTreatingPhysicianId(state)
    const partnerPhysicianId = selectPartnerPhysicianId(state)


    return Boolean((isReassignmentTreatingPhysician && currentTreatingPhysicianId && newTreatingPhysicianId && currentTreatingPhysicianId !== newTreatingPhysicianId) ||
        (isReassignmentPartnerPhysician && currentTreatingPhysicianId && partnerPhysicianId))
}




// WEBPACK FOOTER //
// ./src/modules/treatment/state/reassign/selector.js